module.exports = __webpack_public_path__ + "img/peel_1.ee3720e3.jpg";